import React from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { poleSearchData, setCenterType, showInfoTabType } from '../types/customTypes';
import { CircleFill } from 'react-bootstrap-icons';
import '../assets/styles/SearchPole.scss';

const SearchPole:React.FC<propTypes> = (props: propTypes) => {

    const handleOnSelect = (item) => {
        props.setCenter(item, 17);
        sessionStorage.setItem("latitude", item.latitude);
        sessionStorage.setItem("longitude", item.longitude);
        setTimeout(() => props.showInfoTab(item.id));
    };


    const formatResult = (pole) => {
        return (
            <span>
                <CircleFill className="pole-icon" color={pole.color} size={20} />
                {pole.name}
            </span>
        )
    };

    return (
        <div className="search-pole" data-testid="search-pole">
            <ReactSearchAutocomplete
                items={props.poles}
                onSelect={handleOnSelect}
                formatResult={formatResult}
                onClear={() => props.showInfoTab(0)}
                fuseOptions={{threshold: 0.0, distance: 0, shouldSort:false}}
            />
        </div>
    );
};

type propTypes = {
    showInfoTab: showInfoTabType,
    poles: poleSearchData[],
    setCenter: setCenterType,
    goToPoles: (a) => void,
    setMap: (a) => void,
};

export default SearchPole;